export const loginEndpoint = process.env.REACT_APP_LOGIN_ENDPOINT // sso
export const domainEndpoint = process.env.REACT_APP_DOMAIN_APP // domain
export const serverApiEndpoint = `${process.env.REACT_APP_DOMAIN_APP}/graphql` // app-server
export const logoutEndpoint = `${process.env.REACT_APP_DOMAIN_APP}/sso/landing` // app-server
export const directApiEndpoint = `${process.env.REACT_APP_DOMAIN_API}/graphql` // api
export const tokenApiEndpoint = `${process.env.REACT_APP_DOMAIN_PACS}/token` // pacs
export const serviceNowUrl = process.env.REACT_APP_SERVICENOW // serviceNow
